import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const comparisons = [{
  problem: 'Una web confusa que obliga a explicar lo mismo una y otra vez.',
  solution: 'Una estructura que presenta tu propuesta, servicios y siguiente paso con claridad.',
  focus: 'Claridad comercial'
}, {
  problem: 'Información importante dispersa entre redes, PDFs y mensajes.',
  solution: 'Un punto de referencia que ordena la información que tus clientes necesitan.',
  focus: 'Experiencia unificada'
}, {
  problem: 'Una presencia genérica que no transmite la calidad de tu trabajo.',
  solution: 'Un sistema visual propio, sobrio y coherente con el valor de tu negocio.',
  focus: 'Percepción de marca'
}, {
  problem: 'Cambios cotidianos que se convierten en tareas pendientes eternas.',
  solution: 'Acompañamiento y una base sencilla de mantener después del lanzamiento.',
  focus: 'Continuidad'
}];
export function ProblemSolution() {
  return <section className="section-shell bg-black" aria-labelledby="problem-solution-title" data-id="element-108" data-mp="bqkcq8ov03t5">
      <div className="container mx-auto max-w-6xl px-6 md:px-12" data-id="element-109" data-mp="3u4jrmv5sg3ab">
        <div className="grid gap-8 border-b border-white/10 pb-10 lg:grid-cols-[0.7fr_1.3fr] lg:items-end" data-id="element-110" data-mp="21kdco6g36ef">
          <div data-id="element-111" data-mp="3k6vyg9ntz3u9">
            <p className="eyebrow" data-id="element-112" data-mp="3k6dsglbd9b95">El punto de partida</p>
            <h2 id="problem-solution-title" className="mt-5 text-3xl font-medium tracking-[-0.045em] text-white sm:text-4xl" data-id="element-113" data-mp="3p6idmon7yu5p">
              Cuando lo digital no representa lo que haces, se nota.
            </h2>
          </div>
          <p className="max-w-2xl text-base leading-relaxed text-neutral-300" data-id="element-114" data-mp="3f8m4219xk79p">
            No se trata de añadir más canales. Se trata de crear una experiencia
            ordenada que convierta la atención en conversaciones de calidad.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.15
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 overflow-hidden border border-white/10" data-id="element-115" data-mp="2me60opg9dj4l">
          <div className="hidden grid-cols-[0.95fr_1.05fr] border-b border-white/10 bg-white/[0.025] md:grid" data-id="element-116" data-mp="356i299z38gdo">
            <p className="meta-label px-7 py-4" data-id="element-117" data-mp="3156cn4g7rv5h">Lo que frena</p>
            <p className="meta-label border-l border-white/10 px-7 py-4 text-white" data-id="element-118" data-mp="2waiv5pjmo10e">
              Lo que construimos
            </p>
          </div>
          {comparisons.map((item, index) => <div key={item.focus} className="grid md:grid-cols-[0.95fr_1.05fr]" data-id="element-119" data-mp="3ot698l07ifrz" data-mpi={index}>
              <div className="border-b border-white/10 bg-[#0a0a0a] p-6 md:border-b-0 md:p-7" data-id="element-120" data-mp="3k0mxzuozrwqc">
                <p className="meta-label mb-4 md:hidden" data-id="element-121" data-mp="3rdm36g9v8de8">Lo que frena</p>
                <div className="flex gap-3" data-id="element-122" data-mp="69nk5oms80f">
                  <XIcon size={16} className="mt-1 shrink-0 text-neutral-400" aria-hidden="true" data-id="element-123" data-mp="71kpkxvmdst" />
                  <p className="text-sm leading-relaxed text-neutral-300" data-id="element-124" data-mp="97g4ugz3tmuq">
                    {item.problem}
                  </p>
                </div>
              </div>
              <div className={`bg-[#101010] p-6 md:border-l md:border-white/10 md:p-7 ${index !== comparisons.length - 1 ? 'border-b border-white/10' : ''}`} data-id="element-125" data-mp="j543vj3qtgip">
                <p className="meta-label mb-4 text-white md:hidden" data-id="element-126" data-mp="sv7526l0q0s4">
                  Lo que construimos
                </p>
                <div className="flex gap-3" data-id="element-127" data-mp="wxjypwmhq88j">
                  <CheckIcon size={16} className="mt-1 shrink-0 text-white" aria-hidden="true" data-id="element-128" data-mp="wylluzgs6l6m" />
                  <div data-id="element-129" data-mp="o7ttbmkw5puf">
                    <p className="text-sm leading-relaxed text-neutral-200" data-id="element-130" data-mp="o7blrtss3p77">
                      {item.solution}
                    </p>
                    <p className="meta-label mt-3" data-id="element-131" data-mp="xyoe0mihohdr">{item.focus}</p>
                  </div>
                </div>
              </div>
            </div>)}
        </motion.div>

        <Link to="/servicios" className="link-arrow mt-8" data-id="element-132" data-mp="5aahkb71tt4b">
          Ver qué incluye el sistema{' '}
          <ArrowRightIcon size={15} aria-hidden="true" data-id="element-133" data-mp="18oy2700egl5" />
        </Link>
      </div>
    </section>;
}